import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthConfig, OAuthService } from "angular-oauth2-oidc";
import { Subject } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public authenticationEventObservable: Subject<boolean> =
        new Subject<boolean>();

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    jwt: string;

    authConfig: AuthConfig = {
        issuer: environment.discoveryDocumentEndpoint,
        redirectUri: environment.redirectUri,
        logoutUrl: environment.logoutUrl,
        clientId: environment.clientId,
        dummyClientSecret: environment.dummyClientSecret,
        scope: environment.scope,
        responseType: environment.responseType,
        sessionChecksEnabled: environment.sessionChecksEnabled,
        strictDiscoveryDocumentValidation: environment.strictDiscoveryDocumentValidation,
        skipIssuerCheck: environment.skipIssuerCheck,
        requireHttps: environment.requireHttps,
        showDebugInformation: environment.showDebugInformation,
        //useHttpBasicAuthForPasswordFlow: environment.useHttpBasicAuth
        useHttpBasicAuth: environment.useHttpBasicAuth,
        customQueryParams: environment.customQueryParams
    };

    /**
     *
     * @param router
     * @param oauthService
     */
    constructor(
        private router: Router,
        private oauthService: OAuthService,
        private http: HttpClient
    ) {
        this.oauthService.configure(this.authConfig);
    }

    public logout() {
        this.oauthService.logOut();
    }

    public isAuthenticated(): boolean {
        if (
            this.oauthService.hasValidAccessToken() &&
            this.oauthService.hasValidIdToken()
        ) {
            return true;
        } else {
            return false;
        }
    }

    public login() {
        this.oauthService
            .loadDiscoveryDocumentAndLogin()
            .then((result: boolean) => {
                this.authenticationEventObservable.next(result);
            })
            .catch((error) => {
                this.logout();
            });
    }

    public revokeTokenAndLogout() {
    }

    public refreshToken() {
        this.oauthService.refreshToken();
    }

    public getAccessToken() {
        return this.oauthService.getAccessToken();
    }

    public getIdToken(): string {
        return this.oauthService.getIdToken();
    }

    public getIdentityClaims(): any {
        return this.oauthService.getIdentityClaims();
    }

    getTokenTracy(cuaa) {
        let headers = new HttpHeaders().append('Authorization', this.getAccessToken());
        let uri = `${environment.apiEndPoint}getTokenTracy?cuaa=` + cuaa;
        return this.http.get(uri, { observe: 'response', headers: headers })
    }

    clearSession() {
        sessionStorage.clear();
    }

    clearSessionFromMenu() {
        this.jwt = this.getAccessToken();
        sessionStorage.setItem('cuaaSelezionato', null);
        sessionStorage.setItem('idFascicoloSelezionato', null);
        sessionStorage.setItem('idPcgVersSelezionato', null);
        sessionStorage.setItem('fromPsr', null);
        sessionStorage.removeItem('cuaaSelezionato');
        sessionStorage.removeItem('idFascicoloSelezionato');
        sessionStorage.removeItem('idSoggSelezionato');
        sessionStorage.removeItem('idPcgVersSelezionato');
        sessionStorage.removeItem('fromPsr');
    }

    getUserDetails() {
        let uri = `${environment.apiEndPoint}getUtente`;
        return this.http.get(uri, { observe: 'response', headers: this.headers })
    }

}
